import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import PropTypes from 'prop-types'
import { trackImportContact } from 'data/analytics/actions'
import { setActiveModal, closeActiveModal } from 'data/ui/actions'
import { selectors as ConfigSelectors } from 'data/config'
import { selectors as AuthSelectors } from 'data/auth'
import RoutesHelpers from 'helpers/RoutesHelper'

import { GoogleIcon, SlackIcon } from 'components/Utils/Icons'
import { PopupCenter } from 'lib/utils'

class ProviderBulkImportButton extends React.Component {
  state = {
    displayUserAssociationModal: false,
  }
  static propTypes = {
    provider: PropTypes.string.isRequired,
    onContactsFetchedDone: PropTypes.func,
    apiEndpoint: PropTypes.string.isRequired,
    apiToken: PropTypes.string.isRequired,
  }
  static defaultProps = {
    onContactsFetchedDone: () => {},
  }

  handleButtonClick = event => {
    event.preventDefault()
    const { apiEndpoint, apiToken, provider, trackImportContact } = this.props
    trackImportContact(provider)
    PopupCenter({
      url: RoutesHelpers.contactImport({
        provider,
        apiEndpoint,
        apiToken,
      }),
      title: `import-contact-from-${provider}`,
      requestedWidth: 600,
      requestedHeight: 800,
      onClose: () => {
        this.props.onContactsFetchedDone()
      },
    })
  }

  render() {
    return (
      <div className="background-shade-50-on-active border-shade-30-on-hover border-shade-40 border-small margin-smaller padding-horizontal-small padding-vertical-smaller pointer radius-normal shade-10-on-hover transition">
        {this.props.provider === 'google' && (
          <GoogleIcon size={18} onClick={this.handleButtonClick} />
        )}
        {this.props.provider === 'slack' && (
          <SlackIcon size={18} onClick={this.handleButtonClick} />
        )}
      </div>
    )
  }
}

export default compose(
  connect(
    state => ({
      apiEndpoint: ConfigSelectors.getApiEndpoint(state),
      apiToken: AuthSelectors.getApiToken(state),
    }),
    { setActiveModal, closeActiveModal, trackImportContact }
  )
)(ProviderBulkImportButton)
